import { useState } from 'react';

export function useCadernoSigilo(activeWorkspace) {
  const [editingSigilo, setEditingSigilo] = useState(false);
  const [nivelSigilo, setNivelSigilo] = useState(() => String(activeWorkspace?.nivelSigilo || 'PUBLICO').toUpperCase());
  const [prioridadeAtiva, setPrioridadeAtiva] = useState(() => Boolean(activeWorkspace?.prioridade?.ativa));
  const [prioridadeMotivo, setPrioridadeMotivo] = useState(() => String(activeWorkspace?.prioridade?.motivo || '').trim());

  return {
    editingSigilo, setEditingSigilo,
    nivelSigilo, setNivelSigilo,
    prioridadeAtiva, setPrioridadeAtiva,
    prioridadeMotivo, setPrioridadeMotivo,
  };
}
